<template>
  <div
    :class="cuadHolderClass"
  >
    <div class="cuad-flex">
      <div class="cuad-pre">
        <div class="cuad-clip">
          {{ datum.name }}
          <span class="territory">
            {{ territory }}
          </span>
        </div>
        <div
          class="cuad-end"
          @click="closeModal"
        >
          ╳
        </div>
      </div>
      <div class="cuad-head">
        <div class="cuad-left">
          <h3>{{ popDatum }}</h3>
          <p>{{ $t("txt.populationTotal") }}</p>
        </div>
        <div class="cuad-right">
          <h3>{{ extDatum }} <span>[{{ extPerc }} %]</span></h3>
          <p>{{ $t("txt.origExt") }}</p>
        </div>
      </div>
      <div class="cuad-body">
        <div class="cuad-left">
          <Pie
            id="abs"
            :datum="showAbsDatum()"
            :colors="colors"
            :total="showTotalDatum()"
          />
        </div>
        <div class="cuad-right">
          <Pie
            id="perc"
            :datum="showPercDatum()"
            :colors="colors"
            :total="showExtDatum()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import * as d3 from 'd3'

import Pie from '../../components/common/Pie'

import commonMessages from '../../locales/common'

export default {
  name: 'Cuad',
  i18n: {
    messages: {},
    sharedMessages: commonMessages,
  },
  components: {
    Pie,
  },
  props: {
    pie: {
      type: Array,
      default: () => [],
    },
    datum: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Object,
      default: () => {},
    },
    shown: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'gray',
    },
    territory: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      svg: undefined,
    }
  },
  computed: {
    loc () {
      let loc = this.$i18n.locale
      if (this.$i18n.locale === 'eu') {
        loc = 'es'
      }
      const upper = loc.toUpperCase()
      return `${loc}-${upper}`
    },
    cuadHolderClass () {
      const { color } = this
      const res = (this.shown) ? 'active' : ''
      return [`cuadHolder ${res} border-${color}-500 text-${color} border py-2 px-2 `]
    },
    popDatum () {
      const calc = this.datum.pop
      const res = isNaN(calc) ? 0 : calc
      const resIntl = new Intl.NumberFormat(this.loc).format(res)
      return resIntl
    },
    extDatum () {
      const calc = this.datum.ext
      const res = isNaN(calc) ? 0 : calc
      const resIntl = new Intl.NumberFormat(this.loc).format(res)
      return resIntl
    },
    extPerc () {
      const calc = (this.datum.ext / this.datum.pop) * 100
      const res = isNaN(calc) ? 0 : calc
      const resIntl = new Intl.NumberFormat(this.loc).format(res.toFixed(2))
      return resIntl
    },
    arcGenerator () {
      return d3.arc()
        .innerRadius(0)
        .outerRadius(this.radius)
    },
  },
  mounted () {
    // console.log('colors', this.colors)
  },
  methods: {
    closeModal () {
      this.$parent.resetZoom()
    },
    showAbsDatum () {
      return {
        cat: this.datum.cat,
        mus: this.datum.mus,
        pro: this.datum.pro,
        ort: this.datum.ort,
        jud: this.datum.jud,
        hin: this.datum.hin,
        bud: this.datum.bud,
        otr: this.datum.otr,
        no: this.datum.no,
      }
    },
    showPercDatum () {
      return {
        cat: (this.datum.cat - this.datum.cat_esp),
        mus: (this.datum.mus - this.datum.mus_esp),
        pro: (this.datum.pro - this.datum.pro_esp),
        ort: (this.datum.ort - this.datum.ort_esp),
        jud: (this.datum.jud - this.datum.jud_esp),
        hin: (this.datum.hin - this.datum.hin_esp),
        bud: (this.datum.bud - this.datum.bud_esp),
        otr: (this.datum.otr - this.datum.otr_esp),
        no: (this.datum.no - this.datum.no_esp),
      }
    },
    showTotalDatum () {
      return this.datum.pop
    },
    showExtDatum () {
      return this.datum.ext
    },
  },
}
</script>

<style lang="scss">

@import '@/mixin.scss';

.cuadHolder {
  display: block;
  top: 40%;
  left: 1rem;
  right: 1rem;
  background: white;
  //height: 18rem;
  opacity: 0;
  z-index: -1;
  position: relative;
  left: 0;
  height: 0;
  @media (min-width: 640px) {
    position: absolute;
    top: 40%;
    left:  calc(50% - 180px);
    right: calc(50% - 180px);
  }
  &.active {
    display: block;
    height: auto;
    opacity: 1;
    transition: opacity 1s .1s;
    z-index: 9999;
  }
}

.cuad-pre {
  display: flex;
  flex-direction: row;
  font-size: 1.2rem;
  border-bottom: 1px solid var(--bg-color-alt);
  margin-bottom: .5rem;
  font-weight: 700;
  justify-content: space-between;
  //text-overflow: clip ellipsis;
  .cuad-clip {
    text-overflow: clip ellipsis
  }
  .cuand-end {
    align-self: flex-end;
  }
}

.cuad-head {
  display: flex;
  flex-direction: row;
  .cuad-left,
  .cuad-right {
    white-space: nowrap;
    text-align: center;
    flex: 1;
    p {
      text-transform: uppercase;
      font-size: .8rem;
    }
    h3 {
      font-size: 1.4rem;
      font-weight: 700;
      span {
        //font-weight: 300;
        opacity: .66;
      }
    }
  }
}

.cuad-body {
  display: flex;
  flex-direction: row;
  .cuad-left,
  .cuad-right {
    padding-top: .2rem;
    text-align: center;
    flex: 1;
  }
}

.territory {
  opacity: .72;
  font-weight: 300;
}

.cuad-end {
  cursor: pointer;
}

</style>
